import Cookies from 'js-cookie'
import { fmUserLogin, fmUserChangeUserPwd, loginInfo, generateVerificationCode } from '@/view/api/ajax'
import { Message } from 'element-ui'
import SideMenuUtils from '@/utils/sideMenuUtils'
import MenuUtils from '@/utils/menuUtils'

/* ----------------------------------------*/
let sideMenus = []
let routers = []
let fmMenus = []
//
function loginData(data) {
  window.sessionStorage.setItem('menus', JSON.stringify(data))
  MenuUtils(routers, data)
  window.sessionStorage.setItem('sideMenus', JSON.stringify(sideMenus))
}
//
function filterAsyncRouter(routes) {
  let firstPage = {
    menuId: 1,
    parentId: -1,
    menuNameNick: 'page/index/index',
    menuName: '首页',
    menuNameEn: 'My task',
    hasChild: 'N',
    menuDepth: 2,
    childMenus: []
  };
  const sysMenus = []
  // sysMenus.push(firstPage);
  if (routes.menus && routes.menus.childMenus !== null) {
    routes.menus.childMenus.forEach(v => {
      sysMenus.push(v)
    })
  }
  const menu = {
    path: '/',
    menuNameNick: 'layout/Home',
    menuName: 'LVMH Optimus',
    menuNameEn: 'LVMH Optimus',
    hasChild: 'Y',
    isRoot: true
  }
  menu.childMenus = []
  for (let i = 0; i < sysMenus.length; i++) {
    if (sysMenus[i].menuDepth === 2) {
      menu.childMenus.push(sysMenus[i])
    }
  }
  SideMenuUtils(sideMenus, menu.childMenus)
  fmMenus.push(menu)
  loginData(fmMenus)
}
/* ----------------------------------------*/
const login = {
  namespaced: true,
  state: {
    addRouters: [],
    clients: [],
    checkedData: null,
    yzmRes: null,
  },
  mutations: {
    FM_USER_LOGIN_REQUEST(state, data) {
      state.addRouters = routers
      //
      state.clients = data.clients
      sessionStorage.setItem('clients', JSON.stringify(data.clients))
      sessionStorage.setItem('user', JSON.stringify(data.user))
    },
    SET_LANGUAGE: (state, language) => {
      state.language = language
      Cookies.set('language', language)
    },
    FM_USER_CHANGE_USER_PWD_REQUEST: (state, obj) => {
      state.checkedData = obj
    },
    FM_USER_YZM_CODE: (state, obj) => {
      state.yzmRes = obj
    }
  },
  actions: {
    // 登录请求
    async fmUserLoginRequest({ dispatch, commit }, data) {
      let res = await fmUserLogin(data)
      if (res.code === 200) {
        const { code, obj } = res;
        const { refreshToken, token } = obj;
        localStorage.setItem("token", token);
        localStorage.setItem("refresh", refreshToken);
        localStorage.setItem('changeUser', 'N');
        filterAsyncRouter(obj)
        commit('FM_USER_LOGIN_REQUEST', obj)
        //dispatch('kdOrganization/findAll',{},{root:true});
        //dispatch('kdSortingPlan/findAll',{},{root:true});

        // loginInfo({...obj.user, ...obj.clients}).then(info => {
        //   console.log(info)
        // })
      }
    },
    // 生成验证码
    async generateVerificationCode({ dispatch, commit }, data) {
      var res = await generateVerificationCode(data);
      commit('FM_USER_YZM_CODE', res)
    },
    //切换账号
    async loginInfo({ dispatch, commit }, data) {
      let res = await loginInfo(data)
      if (res.code === 200) {
        const { code, obj } = res;
        const { user } = obj;

        obj.refreshToken = localStorage.getItem("refresh");
        obj.token = localStorage.getItem("token");
        obj.clients = sessionStorage.getItem('clients');

        sideMenus = []
        routers = []
        fmMenus = []

        localStorage.clear();
        sessionStorage.clear();

        localStorage.setItem("ms_username", user.userNo);
        localStorage.setItem("token", obj.token);
        localStorage.setItem("refresh", obj.refreshToken);

        filterAsyncRouter(obj)
        commit('FM_USER_LOGIN_REQUEST', obj)
      }
    },
    //
    setLanguage({ commit }, language) {
      commit('SET_LANGUAGE', language)
    },
    async fmUserChangeUserPwdRequest({ commit }, obj) {
      const resp = await fmUserChangeUserPwd(obj)
      commit('FM_USER_CHANGE_USER_PWD_REQUEST', resp)
    }
  }
}
export default login



// WEBPACK FOOTER //
// ./src/store/modules/login.js